import { Confirm } from '../services/Confirm';

export default function bindings () {
  /**
   * Lazy load images.
   */
  document.querySelectorAll('img[data-src]').forEach((img) => {
    if (img.dataset.src) {
      img.setAttribute('src', img.dataset.src);
    }
  });

  /**
   * Check all checkboxes.
   */
  document.querySelectorAll('[data-check-all]').forEach((anchor) => {
    anchor.onclick = () => {
      let allChecked = true;
      const type = anchor.dataset.checkAll;
      const checks = document.querySelectorAll(`[data-check="${type}"]`);

      checks.forEach((box) => {
        allChecked = allChecked && box.checked;
        box.checked = ! allChecked;
      });
    };
  });

  /**
   * Add event listeners to confirm links.
   */
  const confirms = document.querySelectorAll('.confirm');
  const confirmCallback = async function (event) {
    event.preventDefault();

    if (await Confirm(this.getAttribute('data-confirm'))) {
      window.location = this.getAttribute('href');
    }
  };

  for (var i = 0; i < confirms.length; i++) {
    confirms[i].addEventListener('click', confirmCallback);
  }

  /**
   * Add event listeners to confirm deletes.
   */
  const destroys = document.querySelectorAll('.destroy');
  const destroyCallback = async function (event) {
    event.preventDefault();

    if (await Confirm(this.getAttribute('data-confirm'))) {
      this.submit();
    }
  };

  for (var i = 0; i < destroys.length; i++) {
    destroys[i].addEventListener('click', destroyCallback);
  }

  document.querySelectorAll('.modal').forEach(() => {
    document.body.insertAdjacentElement('beforeend', document.querySelector('.modal'));
  });

  document.querySelectorAll('td[data-href]').forEach((td) => {
    td.onclick = (e) => {
      e.preventDefault();

      const html = td.innerHTML.trim();

      if (html.length === 0) {
        return false;
      }

      const { href } = td.dataset;

      if (e.shiftKey || e.ctrlKey || e.metaKey) {
        window.open(href, '_blank');
      } else {
        window.document.location = href;
      }

      return false;
    };
  });

  const cardHeader = document.querySelector('.nav.nav-tabs.flex-column.card-header.h-100.border-bottom-0.rounded-0');
  if (cardHeader) {
    cardHeader.classList.remove('rounded-0');
    cardHeader.classList.add('rounded-1');
  }
}
